export default __webpack_public_path__ + "static/media/products-7.14523438.webp";